import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { isAxiosError } from "axios";
import { useCompleteGoogleSheetsConnectionMutation } from "@api/googleSheetsAddon.api";
import { hasAccessToken } from "@lib/auth0";

function getErrorMessage(error: Error | null): string {
    if (isAxiosError<{ message?: string }>(error)) {
        return (
            error.response?.data?.message ?? "Failed to connect Google Sheets"
        );
    }
    return "Failed to connect Google Sheets";
}

export const GoogleSheetsConnectCallback: React.FC = () => {
    const [searchParams] = useSearchParams();
    const state = searchParams.get("state");
    const code = searchParams.get("code");
    const isSignedIn = hasAccessToken();
    const { mutate, status, error } =
        useCompleteGoogleSheetsConnectionMutation();
    const hasStartedRef = useRef(false);

    useEffect(() => {
        if (hasStartedRef.current || !state || !code || !isSignedIn) {
            return;
        }
        hasStartedRef.current = true;
        mutate({ state, code }, { onSuccess: () => window.close() });
    }, [state, code, isSignedIn, mutate]);

    if (!state || !code) {
        return <p>Couldn't authorize access</p>;
    }
    if (!isSignedIn) {
        return (
            <p>
                Sign in to Kick in this browser, then connect again from Google
                Sheets
            </p>
        );
    }
    if (status === "success") {
        return <p>Google Sheets connected. You can close this tab.</p>;
    }
    if (status === "error") {
        return <p>{getErrorMessage(error)}</p>;
    }
    return <p>Connecting Google Sheets…</p>;
};
